import { TemplatePage } from './types';

const adsPromoTestimonialsPage: TemplatePage = {
  header: {
    color: '#A3D1E0',
    icon: 'images/video-templates/customer-testimonial.jpg',
    title: 'Customer Testimonial Video Templates',
    title_meta: '30+ Free Customer Testimonial Video Templates',
    description_meta:
      'Build trust and credibility for your brand with Wave.video’s 30+ editable customer testimonial video templates.',
    description:
      'Build trust and credibility for your brand with these 30+ editable customer testimonial video templates. ' +
      'Turn reviews, use cases, and testimonials into eye-catching videos that your potential and existing customers ' +
      'would love to watch.'
  },
  footer: {
    category: 'testimonials',
    description:
      'Wave.video’s collection of customer testimonial video templates helps create eye-catching and informative ' +
      'videos for your blog, website, email newsletter, or social media. All the templates are easy and free to ' +
      'customize to suit your branding.'
  },
  content: [
    {
      type: 'templates',
      title: 'Customer Testimonial Video',
      search: { category: '/Use Cases/Customer Testimonial' }
    },
    {
      type: 'stocks',
      title: 'customer testimonial',
      search: { name: 'customer testimonial' }
    },
    { type: 'calendar' }
  ]
};

export default adsPromoTestimonialsPage;
